export enum MdsShortcutKeyCharacter {
  Command = "Command",
  C = "C",
  Backslash = "Backslash",
}
